import {MutationTree} from "vuex";
import {ContractProfileState, ContractProfile} from "./model";

const mutations: MutationTree<ContractProfileState> = {
  setContractProfiles(state, contractProfiles: ContractProfile[]) {
    state.contractProfiles = contractProfiles;
  },
  addContractProfile(state, contractProfile: ContractProfile) {
    state.contractProfiles.push(contractProfile);
  },
  updateContractProfile(state, contractProfile: ContractProfile) {
    const index = state.contractProfiles.findIndex(c => c.id === contractProfile.id);
    if(index !== -1) {
      state.contractProfiles.splice(index, 1, contractProfile);
    }
  },
  deleteContractProfile(state, id: string) {
    const index = state.contractProfiles.findIndex(c => c.id === id);
    if(index !== -1) {
      state.contractProfiles.splice(index, 1);
    }
  }
}

export default mutations;
